import React from "react";
const Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="6"
        height="5"
        viewBox="0 0 6 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1 1.66699L3 3.66699L5 1.66699"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Icon;
